import { useLoaderData } from 'react-router';
import { useSubmitLead } from '../../../common/hooks/useSubmitLead';
import { backMsg, t } from '../../../common/i18n/index.js';
import { SmallHeader } from '../../../components/SmallHeader/SmallHeader.js';
import {
  TrainingEnrollment,
  setAdditionalInformationSchema,
} from '../../../components/TrainingEnrollment/TrainingEnrollment.js';
import { useAuth } from '../AuthProvider.js';
import { DataLoader } from '../siteUtils.js';
import type { TrainingResponse } from '../../../generated/api/models.js';

export const TrainingEnrollmentPath = () => {
  const { leadState, submitLead } = useSubmitLead();
  const { authenticatedUser } = useAuth();
  const trainingData = useLoaderData() as TrainingResponse;

  return (
    <>
      <SmallHeader buttonText={t.D1E9(backMsg)} onClick={() => window.history.back()} />
      <DataLoader>
        <div id="of-training">
          {trainingData.trainingContent?.length && (
            <TrainingEnrollment
              leadState={leadState}
              submitLead={submitLead}
              contactId={authenticatedUser?.contact?.contactId}
              trainingResponse={trainingData}
              trainingSchema={trainingData.trainingContent}
              defaultValues={
                authenticatedUser?.businessId
                  ? {
                      businessId: authenticatedUser.businessId,
                      businessName: authenticatedUser.companyName,
                      firstName: authenticatedUser.firstName,
                      lastName: authenticatedUser.lastName || '',
                      phoneNumber: authenticatedUser.mobile || '',
                      email: authenticatedUser.email || '',
                      additionalInformation: '',
                      trainingId: trainingData.trainingContent[0].id,
                    }
                  : {
                      trainingId: trainingData.trainingContent[0].id,
                    }
              }
              additionalInformationSchema={setAdditionalInformationSchema(trainingData.additionalInformation || {})}
            />
          )}
        </div>
      </DataLoader>
    </>
  );
};
